export const LIMIT_PARTS_ACCESSORIES = 6;
export const ACCESSORIES_ATTR = 'accessories';
